export const SUPPORT_NOTIFICATION_TYPE = 'support_message'
export const SUPPORT_PUSH_VERSION = 1
export const SUPPORT_ANDROID_CHANNEL = 'hubbing-support'
const uuid = value => typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)

// Member inbox readiness is independent of the web-only staff portal. This code
// reaches phones only in a future signed build; no remote native rollout occurs.
export const memberSupportEnabled = (hostname, native = false) => native === true || String(hostname || '').toLowerCase() === 'app.hubbing.ch'
export const supportNotificationText = lang => ({title:'Support Hubbing',body:({fr:'Vous avez reçu un message du Support Hubbing.',de:'Sie haben eine Nachricht vom Support Hubbing erhalten.',en:'You have received a message from Support Hubbing.',it:'Hai ricevuto un messaggio dal Support Hubbing.'})[lang]||'Vous avez reçu un message du Support Hubbing.'})

export function supportMessageTarget(notification) {
  const data = notification?.data && typeof notification.data === 'object' ? notification.data : notification
  if (!data || data.type !== SUPPORT_NOTIFICATION_TYPE) return null
  const threadId = data.supportThreadId || data.support_thread_id
  const messageId = data.supportMessageId || data.support_message_id
  const notificationId = data.notificationId || data.id
  if (!uuid(threadId)) return null
  return {threadId, messageId:uuid(messageId)?messageId:null, notificationId:uuid(notificationId)?notificationId:null}
}
export const supportThreadIdFromNotification = notification => supportMessageTarget(notification)?.threadId || null

export function createSupportNotificationRouter({onOpen, onRefresh} = {}) {
  const handled = new Set()
  return (notification, meta = {}) => {
    const target = supportMessageTarget(notification)
    if (!target) return false
    onRefresh?.()
    if (meta.action !== 'performed') return true
    const key = target.messageId || target.notificationId || target.threadId
    if (handled.has(key)) return true
    handled.add(key)
    if (handled.size > 100) handled.delete(handled.values().next().value)
    onOpen?.(target)
    return true
  }
}
